import moment from "moment";
import {
  CREDIT_TRANSFER_REPORT_LOADING,
  SET_CREDIT_TRANSFER_TYPES,
  SET_CREDIT_TRANSFER_SUBTYPES,
  SET_CREDIT_TRANSFER_STATS,
  RESET_CREDIT_TRANSFER_REPORTS,
  ADD_CREDIT_TRANSFER_REPORT_ERROR,
  CREDIT_TRANSFER_REPORT_DOWNLOADED,
} from "../constants";

// State
import { CREDIT_TRANSFER_SESSION_TOKEN } from "../actions/creditTransferActions";

let SAVED_STATE = JSON.parse(sessionStorage.getItem(CREDIT_TRANSFER_SESSION_TOKEN));
if (SAVED_STATE && moment().isAfter(SAVED_STATE.expires_at)) {
  SAVED_STATE = null;
}

const initial_state = {
  errors: {},
  loading: {},

  // User selected options
  options: {
    startDateTime: moment().subtract(1, "day").startOf("day"), // Default: start of yesterday
    endDateTime: moment().endOf("day"), // Default: through today
    types: "all", // BILL_TO_DATE, DISCONNECT, EBILL, ...
    subTypes: "all", // COMPLETE, NEW, PAYMENT_RECEIVED, ...
    companyCode: "all", // Illinois, Missouri, ...
    expires_at: moment().add(1, "hour").toJSON(),
    ...SAVED_STATE,
  },

  // Options for dropdowns
  types: [], // "BILL_TO_DATE", "DISCONNECT", "EBILL", ...
  subTypes: [], // "COMPLETE", "NEW", "PAYMENT_RECEIVED", ...
  companyCodes: [], // "Illinois", "Missouri", ...

  // Display Data based on selections above
  stats: {
    /* transfer: [{ dispatched: Number, delivered: Number, ...}, sms: [{...}] */
  },
};

export default function (state = initial_state, { type, payload, name }) {
  let { loading, errors } = state;

  switch (type) {
    case CREDIT_TRANSFER_REPORT_LOADING:
      loading[payload] = true;
      delete errors[payload]; // clear previous errors
      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
      };
    case ADD_CREDIT_TRANSFER_REPORT_ERROR:
      // If provided, clear loading
      name && (loading[name] = false);

      if (payload.message) {
        payload = {
          [name]: "There was a problem. Please try again later",
        };
      }

      // Set errors
      errors = {
        ...errors,
        ...payload,
      };
      return {
        ...state,
        errors,
        loading: { ...loading },
      };

    case SET_CREDIT_TRANSFER_TYPES:
      loading["types"] = false;
      delete errors["types"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        types: payload || [],
      };

    case SET_CREDIT_TRANSFER_SUBTYPES:
      loading["subTypes"] = false;
      delete errors["subTypes"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        subTypes: payload || [],
      };

    case SET_CREDIT_TRANSFER_STATS:
      loading["stats"] = false;
      delete errors["stats"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        stats: (payload && payload.stats) || [],
      };

    case CREDIT_TRANSFER_REPORT_DOWNLOADED:
      loading["credittransfer_download"] = false;
      delete errors["credittransfer_download"]; // clear previous errors

      return state;

    case RESET_CREDIT_TRANSFER_REPORTS:
      return { ...initial_state };

    default:
      return state;
  }
}
